import { Dialog } from "primereact/dialog";
import "./PendingEmailsListModal.scss";
import { Button } from "antd";
import { markProspectClientsEmailAsIgnored } from "../../../api";
import { useSelector } from "react-redux";

export default function PendingEmailsListModal({
  isOpen,
  setIsOpen,
  data,
  setData,
  setSelectedEmailToProcess
}) {
  const { token } = useSelector((state) => state.auth);

  const ignoreEmail = (emailData) => {
    if (emailData.id) {
      markProspectClientsEmailAsIgnored({
        token,
        emailId: emailData.id
      }).then(() => {
        setData((prevState) => {
          return prevState.filter(it => it.id !== emailData.id)
        });
      })
    }
  }

  return (
    <Dialog
      visible={isOpen}
      onHide={() => setIsOpen(false)}
      style={{ width: '612px', height: '600px' }}
      resizable={true}
      className="prospect_pending_emails_list"
      showHeader={true}
      header={
        <h5 className="title">E-mails en attente de traitement</h5>
      }
    >
      <div className="list">
        {data.map((item => (
          <div key={item.id} className="list_item">
            <div className="email_data">
              <p className="subject">{item.subject}</p>
              {/* <p dangerouslySetInnerHTML={{ __html: item.body}} /> */}
              {/* <p className="email">{item.body}</p> */}
            </div>
            <div className="buttons">
              <Button
                className="process_button"
                onClick={() => setSelectedEmailToProcess(item)}
              >
                Traiter
              </Button>
              <span
                className="ignore_button"
                onClick={() => ignoreEmail(item)}
              >
                Ignorer
              </span>
            </div>
          </div>
        )))}
      </div>
    </Dialog>
  )
}
